<template>
  <div class="auth-settings">
    <div class="flex-grid">
      <div class="column--two">
        <div>
          <label class="form-label">Primary Authentication Method</label>
          <p class="sub-label m-0">
            Select one primary authentication method to enable for your users
          </p>
          <select
            v-model="authType"
            class="form-field select-dropdown"
            data-testid="auth-method-dropdown"
          >
            <option
              v-for="type in authTypes"
              :key="type.value"
              :value="type"
            >
              {{ type.label }}
            </option>
          </select>
          <div
            class="pin-tooltip"
            data-testid="pin-tooltip-p"
          >
            {{ authType.message }}
          </div>
          <div
            v-if="authType.consentNeeded"
            class="biometric-tooltip"
            data-testid="biometric-tooltip-p"
          >
            <input
              id="biometric-consent-check"
              v-model="biometricConsentCheck"
              type="checkbox"
            />
            I have read and complied with the above. <span class="required">*</span>
          </div>
        </div>
      </div>
      <div class="column--two">
        <label class="form-label">Secondary Authentication Method</label>
        <p class="sub-label m-0">
          Additional authentication methods, that can be used to enhance security
        </p>
        <div class="flex-grid-row">
          <toggle
            data-testid="two-credential-auth-toggle"
            class="mt-1"
            :toggle="twoCredentialAuthToggle"
            @toggle-clicked="toggleTwoCredentialAuth"
          />
          <label class="pl-1 mt-1 form-label">Two Credential Authentication</label>
        </div>
        <div class="flex-grid-row mt-1">
          <p class="sub-label mr-1">Rules</p>
          <select
            class="form-field select-dropdown"
            data-testid="2pa-auth-dropdown"
            v-model="twoPersonAuthMode"
            :disabled="!twoCredentialAuthToggle">
            <option
              v-for="type in twoPersonAuthModes"
              :key="type.value"
              :value="type">
                {{ type.label }}
              </option>
          </select>
        </div>
      </div>
    </div>
    <div
      class="alert alert-danger mt-3"
      data-testid="reboot-alert-div"
    >
      <strong>Warning: Reboot Required</strong>
      <p class="m-0">
        By making this change, the device will reboot. Please give the device a few minutes for
        changes to take effect.
      </p>
    </div>

    <div class="modal_footer">
      <button
        id="cancel-device-settings-modal"
        class="btn btn--grey"
        @click="emitCancel"
      >
        Cancel
      </button>
      <div class="error">
        {{ errorMessage }}
      </div>
      <div v-tooltip="{ content: emitSettingsDisabled() ? 'Consent checkbox required' : '' }">
        <button
          id="submit-device-auth-settings-modal"
          class="btn"
          type="submit"
          :disabled="emitSettingsDisabled()"
          @click="emitSettings"
        >
          Save Settings
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/global/constants.js'
import toggle from '../toggle.vue'

export default {
  name: 'AuthenticationSettings',
  components: {
    toggle,
  },
  props: ['device'],
  data() {
    return {
      errorMessage: '',
      twoCredentialAuthToggle: false,
      authTypes: constants.authenticationModes,
      authType: constants.authenticationModes[0],
      twoPersonAuthModes: constants.twoPersonAuthModes,
      twoPersonAuthMode: constants.twoPersonAuthModes[0],
      biometricConsentCheck: false,
    }
  },
  created() {
    this.setup()
  },
  methods: {
    toggleTwoCredentialAuth() {
      /*
       * By default 2 Credential Auth is disabled by setting
       * the field twoPersonAuthTimeout = 0. When enabled
       * this field is set to a timeout of 60s to let the back
       * end know that 2 CA is active for this device
       */
      if (this.device.twoPersonAuthTimeout === 0) {
        this.device.twoPersonAuthTimeout = constants.twoCredentialAuthTimeout
      } else {
        this.device.twoPersonAuthTimeout = 0
      }
      this.setToggle()
    },
    setup() {
      this.twoCredentialAuthToggle = this.device.twoPersonAuthTimeout > 0

      this.authType = this.authTypes.find(t => t.value == this.device.authenticationMode)
      if (this.authType.consentNeeded) {
        this.biometricConsentCheck = true
      }

      this.twoPersonAuthMode = this.twoPersonAuthModes.find(t => t.value === this.device.twoPersonAuthMode)
    },
    setToggle() {
      this.twoCredentialAuthToggle = this.device.twoPersonAuthTimeout > 0
    },
    emitCancel() {
      this.$emit('cancel')
    },
    emitSettings() {
      this.device.twoPersonAuthMode = this.twoPersonAuthMode.value
      this.device.authenticationMode = this.authType.value
      this.$emit('submit-auth-method-settings', this.device)
    },
    emitSettingsDisabled() {
      return this.authType.consentNeeded && !this.biometricConsentCheck
    },
  },
}
</script>

<style lang="scss" scoped>
.required {
  color: $red;
  vertical-align: super;
  font-size: smaller; /* Optional: to make the asterisk smaller */
}
</style>
